import React, { useState, useEffect } from 'react';
import classes from './../TrialstatNoto.module.css';
import { Button, Row, Col } from 'react-bootstrap';
import InputContainer from '../UI/Container/InputContainer';
import InputString from '../UI/Control/InputString';
import TextArea from '../UI/Control/InputTextarea';
import MandatoryLabel from '../UI/Control/MandatoryLabel';

const ClosedWithIssue = (props) => {
    const [arrQueryDetails, setArrQueryDetails] = useState([]);

    const GetQueriesByTaskID = () => {
        fetch('api/TaskQuery/GetQueriesByTaskID?taskId=' + props.taskId)
            .then(response => response.json())
            .then(data => {
                setArrQueryDetails(data.listQueryDetails);
            });
    }
    useEffect(() => {
        GetQueriesByTaskID();
    }, []);

    const SaveClosedWithIssue = (event) => {

        let objNotes = document.getElementById('txtNotes');
        if (objNotes.value.trim() == '') {
            alert('Notes should not be empty.');
            objNotes.focus();
            return false;
        }

        let model = {
            TaskID: props.taskId,
            listClosedQueryModel: new Array(),
            Notes: objNotes.value
        };

        let objComment = document.getElementsByName('txtComment');
        let queryId = 0;
        for (var cnt = 0; cnt < objComment.length; cnt++) {
            let id = objComment[cnt].id;
            let querId = id.split('_')[1];
            let queryComment = document.getElementById(id).value.trim();
            if (queryComment != '') {
                model.listClosedQueryModel.push({ QueryId: querId, QueryComment: queryComment });
            }
        }

        fetch('api/ImageService/SaveClosedWithIssue', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('Colsed with issue not saved, Something went wrong.');
            }
            if (res > 0) {
                props.relaodAction();
            }
        })

    };

    return (
        <div>
            {
                <Row id="rowQueryDetails">
                    <Col md={12} >
                        <InputContainer Expended='false' header="Closed Issues" style={{ textAlign: "center", marginTop: "15px" }}>
                            <Row style={{ marginLeft: "5px" }}>
                                <Col md={2} className={classes.cellRLBBorder}><b>Query ID</b></Col>
                                <Col md={2} className={classes.cellRightBorder}><b>Status</b></Col>
                                <Col md={2} className={classes.cellRightBorder}><b>Created By</b></Col>
                                <Col md={3} className={classes.cellRightBorder}><b>Created Date</b></Col>
                                <Col md={3} className={classes.cellRightBorder}><b>Comment</b></Col>
                            </Row>
                            {arrQueryDetails.map((item, index) =>
                                <Row className key={index} style={{ marginLeft: "5px" }}>
                                    <Col md={2} className={classes.cellRLBBorder}>{item.QueryID}</Col>
                                    <Col md={2} className={classes.cellRightBorder}>{item.QueryStatus}</Col>
                                    <Col md={2} className={classes.cellRightBorder}>{item.CreationUser}</Col>
                                    <Col md={3} className={classes.cellRightBorder}>{item.CreationDate}</Col>
                                    <Col md={3} className={classes.cellRightBorder}>
                                        <InputString id={"txtComment_" + item.QueryID} name="txtComment" width="100px" maxlength="249" />
                                    </Col>
                                </Row>
                            )}
                        </InputContainer>
                    </Col>
                </Row>
            }

            <Row className="mt-2 mb-2">
                <Col md={1} style={{ marginLeft:"5px" }}>Notes<MandatoryLabel></MandatoryLabel>: </Col>
                <Col md={9}>
                    <TextArea id="txtNotes" rows='5' cols='100' />
                </Col>
                <Col md={1}><Button style={{ marginTop: "90px" }} className="btn-success" onClick={SaveClosedWithIssue} > Submit </Button></Col>
            </Row>  
        </div>
    );
};

export default ClosedWithIssue;
